import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNewspaper } from "@fortawesome/pro-regular-svg-icons/faNewspaper";

export const defaultTranslations = {
    pluginName: "Articles",
    pluginDescription: "Add articles",
};

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faNewspaper} size="3x" />,
};
